import { useState, useEffect } from 'react';

const useFilter = (dataToFilter) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    const filteredArray = dataToFilter.filter((item) =>
      Object.values(item).some((value) => {
        if (value === null || typeof value !== 'string') {
          return false;
        }
        return typeof value === 'string' && value.toLowerCase().includes(searchTerm ? searchTerm.toLowerCase() : '');
      })
    );

    setFilteredData(filteredArray);
  }, [searchTerm, dataToFilter]);

  return { filteredData, searchTerm, setSearchTerm };
};
export default useFilter;
